import { Component, Inject, OnInit } from '@angular/core';
import { SafetyInductionService } from '../../../services/safety-induction.service';
import { InductionExternalAttendeeseVM, UsersVM } from '../../perform-induction';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
export interface DialogData {
  ArrExternalPersonsInducted:UsersVM[]
}
@Component({
  selector: 'app-dialog-find-attendee',
  templateUrl: './dialog-find-attendee.component.html',
  styleUrls: ['./dialog-find-attendee.component.css']
})
export class DialogFindAttendeeComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DialogFindAttendeeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _inductionService: SafetyInductionService,) { }

    fName:string;
    lName:string;
    EmailAddress:string;
    Company:string;
    Position:string;
    FindAttendeeResult:InductionExternalAttendeeseVM[]
    loading:boolean=false;
    SelectedAttendees:InductionExternalAttendeeseVM[]

  ngOnInit() {

    

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmitClick(): void {
    this.loading=true

    console.log("data__",this.fName,this.lName, this.Company,this.Position,this.EmailAddress)
    this._inductionService.SearchExternalAttendee(this.fName,this.lName, this.Company,this.Position,this.EmailAddress).subscribe(res=>{
      if(this.data.ArrExternalPersonsInducted && this.data.ArrExternalPersonsInducted.length >0){
      let arr = res
      arr.map(m=>{
        let check = this.data.ArrExternalPersonsInducted.find(f=>f.UserAuto == m.UserId)
        if(check){
          m.check = true
        }
      })

      this.FindAttendeeResult=arr;
      }else{
        this.FindAttendeeResult=res;
      }
     
    this.loading=false

    })
  }

  onDoneClick(){
    this.dialogRef.close({
      result:true,
      data:this.SelectedAttendees
    });
  }

  ClickAddInductionAttendee(user){
    let arr = this.SelectedAttendees && this.SelectedAttendees.length >0?this.SelectedAttendees:[]
    //check user exit
    let check = arr.find(f=>f.UserId == user.UserId)
    if(check){
      arr.map(m=>{
        if(m.UserId == user.UserId){
          m.check = !m.check
        }
      })
    }else{
      arr.push(user)

    }
    this.SelectedAttendees = arr

    let _arr = this.FindAttendeeResult
    _arr.map(m=>{
      if(m.UserId == user.UserId){
        m.check = !m.check
      }
    })

    this.FindAttendeeResult =_arr

  }

}
